<template>
  <footer>
    <div>
      <div class="partners">
        <a
          id="women-and-drones"
          href="https://womenanddrones.com"
          target="_blank"
        >
          <img src="@/assets/images/women-and-drones-logo.png" />
        </a>
        <a id="zephyr" href="https://zephyr-sim.com" target="_blank">
          <img src="@/assets/images/zephyr-logo.png" />
        </a>
      </div>
      <div>
        <p>
          ©{{ year }} Kids with Drones. ©{{ year }} Women and Drones. ©{{
            year
          }}
          Zephyr.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
class Footer extends Vue {
  year = new Date().getFullYear();
}

export default Footer;
</script>

<style lang="scss" scoped>
footer {
  // background: #0095ff;
  > div {
    // max-width: 800px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    text-align: center;
    padding: 40px 0;

    > div {
      padding: 20px;

      &.partners {
        padding: 40px 20px 0;
        text-align: center;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        z-index: 99;
        animation: fadeIn 1s both;
        animation-delay: 1.5s;

        > a {
          margin: 20px 10px;
          transition: 0.25s;

          > img {
            margin: 0 30px;
            height: 50px;
          }

          &:hover {
            transform: scale(1.1);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue